import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f85a94fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f85a94fa&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=f85a94fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85a94fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f85a94fa')) {
      api.createRecord('f85a94fa', component.options)
    } else {
      api.reload('f85a94fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f85a94fa&scoped=true", function () {
      api.rerender('f85a94fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/practice/index.vue"
export default component.exports